import { Component, Input } from '@angular/core';

/** PrimeFlex color names used for the icon tile background and icon color. */
export type StatCardColor = 'blue' | 'green' | 'red' | 'orange' | 'cyan';

@Component({
  selector: 'app-stat-card',
  standalone: true,
  templateUrl: './stat-card.component.html',
  styleUrl: './stat-card.component.scss',
})
export class StatCardComponent {
  @Input() icon = '';
  @Input() label = '';
  @Input() value: number | null | undefined = 0;
  @Input() color: StatCardColor = 'blue';
}
